<template>
  <div :class="classes()">
    <div :class="`${el}__inner`">
      <input
        type="checkbox"
        :name="name"
        :class="`${el}__input`"
        :checked="inputChecked"
        :disabled="disabled"
        v-on="{ ...$listeners, change: (event) => $emit('change', event.target.value) }"
      />
      <label
        :class="`${el}__label`"
        v-on:click="toggle"
        tabindex="0"
        @keyup.enter="toggle"
        @keyup.space="toggle"
      >
        <div :class="`${el}__labelInner`">
          <span :class="`${el}__text`">
            <Icon
              v-if="inputChecked"
              color="neutral0"
              name="check-fill"
              size="m"
              :class="`${el}__svg`"
            />
            <template v-if="label">
              {{ label }}
            </template>
            <template v-if="$slots.label">
              <slot name="label" />
            </template>
            <Copy v-if="subLabel" element="div" :staticClass="`${el}__subLabel`">
              {{ subLabel }}
            </Copy>
            <div v-if="$slots.subLabel" :class="`${el}__subLabel`">
              <slot name="subLabel" />
            </div>
          </span>
        </div>
      </label>
      <Copy
        v-if="error"
        element="div"
        size="s"
        :staticClass="`${el}__helperText`"
        color="supportDanger"
      >
        {{ error }}
      </Copy>
    </div>
  </div>
</template>

<script>
import Icon from '@/objects/Icon';
import Copy from '@/objects/Copy';
export default {
  name: 'BaseCheckbox',
  components: {
    Icon,
    Copy,
  },
  props: {
    name: String,
    label: String,
    subLabel: String,
    checked: {
      type: Boolean,
      default: false,
    },
    error: {
      type: [String, Boolean],
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    advanced: {
      type: Boolean,
      default: false,
    },
    hasMargin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputChecked: this.checked,
      el: 'o-baseCheckbox',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          'is-error': this.error,
          'is-disabled': this.disabled,
          [`${el}--bordered`]: this.bordered,
          [`${el}--hasMargin`]: this.hasMargin,
          [`${el}--advanced`]: this.advanced,
          [`${el}--checked`]: this.inputChecked,
        };
      },
    };
  },
  mounted() {
    const links = this.$el.querySelectorAll('a');
    links.forEach((link) => {
      link.addEventListener('click', (event) => this.preventTriggerCheckbox(event, link));
    });
  },
  beforeDestroy() {
    const links = this.$el.querySelectorAll('a');
    links.forEach((link) => {
      link.removeEventListener('click', (event) => this.preventTriggerCheckbox(event, link));
    });
  },
  watch: {
    checked: function () {
      this.inputChecked = this.checked;
    },
  },
  methods: {
    preventTriggerCheckbox(event, link) {
      event.stopPropagation();
      event.preventDefault();
      window.open(link.href, link.target);
      return false;
    },

    toggle() {
      this.inputChecked = !this.inputChecked;
      this.$emit('input', this.inputChecked);
    },
  },
};
</script>
